import { useEffect, useState } from 'react'
import FailedScreen from '../FailedScreen/FailedScreen'
import RegistrationScreenSuccess from '../RegistrationScreenSuccess/RegistrationScreenSuccess'
import PaymentFailedScreen from '../FailedScreen/PaymentFailedScreen'

enum Result {
  SUCCESS = 'success',
  PARTIAL_FAILED = 'partial_failed',
  FAILED = 'failed',
}

export default function ResultScreen() {
  const [result, setResult] = useState<Result | undefined>(undefined)

  useEffect(() => {
    const url = new URLSearchParams(window.location.search)
    const status = url.get('status')

    if (status === 'success') {
      setResult(Result.SUCCESS)
    } else if (status === 'partial_failed') {
      setResult(Result.PARTIAL_FAILED)
    } else {
      setResult(Result.FAILED)
    }
  }, [])

  if (result === undefined) {
    return <div>Loading...</div>
  }

  if (result === Result.SUCCESS) {
    return <RegistrationScreenSuccess />
  } else if (result === Result.PARTIAL_FAILED) {
    return <PaymentFailedScreen />
  }

  return <FailedScreen />
}
